module.exports = __webpack_public_path__ + "img/1541052525.b2bd5135.jpg";